
import * as React from "react"
import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground",
          
          // Removed explicit bg-background class to allow transparency
          
          // Focus and hover styles enhanced
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
          "focus-visible:shadow-md focus-visible:border-amber-400",
          "hover:border-amber-300 transition-all duration-300",
          
          // Responsive text size
          "md:text-sm",
          
          // Error state
          props["aria-invalid"] === "true" && "border-destructive ring-destructive focus-visible:ring-destructive",
          
          // Animation for focus and error state
          "animate-in fade-in-50 data-[state=invalid]:animate-shake",
          
          // Glass effect
          "backdrop-blur-[2px]",
          
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
